import { LicenseTypeQueryParams } from "@rms-types/modules/license-type/dto";

import { getStringWithParams } from "@/helpers";

const index = "license-type";

const getLicenseTypeWithParams = (params?: LicenseTypeQueryParams) =>
  getStringWithParams({
    base: index,
    params,
  });

export const licenseTypeEndpoint = Object.freeze({
  index,
  getLicenseTypeWithParams,
});
